/**
 * Names of fields that can be rendered by the Customer Details Form Field component.
 */
export var CustomerDetailsFormFieldName;
(function (CustomerDetailsFormFieldName) {
    /**
     * The Email field renders an input for the customer's email address.
     */
    CustomerDetailsFormFieldName["Email"] = "Email";
    /**
     * The FamilyName field renders an input for the customer's family name.
     */
    CustomerDetailsFormFieldName["FamilyName"] = "FamilyName";
    /**
     * The GivenName field renders an input for the customer's given name.
     */
    CustomerDetailsFormFieldName["GivenName"] = "GivenName";
    /**
     * The PhoneNumber field renders an input for the customer's phone number.
     */
    CustomerDetailsFormFieldName["PhoneNumber"] = "PhoneNumber";
})(CustomerDetailsFormFieldName || (CustomerDetailsFormFieldName = {}));
